import { RouteObject } from "react-router-dom";
import BillFlow from "./components/billFlow/billFlow";
export interface SingleBillGenerationRoute
  extends Omit<RouteObject, "children"> {
  auth?: boolean;
  children?: SingleBillGenerationRoute[];
}
export const bxSingleBillGenarationRoutes: SingleBillGenerationRoute[] = [
  {
    path: "bx/single-bill-generation",
    element: <BillFlow />,
  },
  {
    path: "bx/single-bill-generation/:id/:action",
    element: <BillFlow />,
  },
  {
    path: "bx/single-bill-generation/:id/:draftId/:action",
    element: <BillFlow />,
  },
];
